// One request per selected lead, all of them attempted, and an honest account of which failed:
// "97 moved, 3 did not" must reach the person, never "nothing happened" or a silent half-job.
export async function runForEach(ids, run) {
  const results = await Promise.allSettled(ids.map((id) => run(id)));
  const failed = [];
  let firstReason = null;
  results.forEach((result, index) => {
    if (result.status === "rejected") {
      failed.push(ids[index]);
      if (firstReason === null) firstReason = result.reason;
    }
  });
  return { failed, firstReason };
}

export function bulkOutcomeMessage(total, failedCount, reasonText, verb = "updated") {
  if (!failedCount) return "";
  const why = reasonText ? ` ${reasonText}` : "";
  if (failedCount === total) return `None of the ${total} leads could be ${verb}.${why}`;
  return `${total - failedCount} of ${total} leads ${verb}. ${failedCount} could not be changed and stay selected.${why}`;
}
